// extracted by mini-css-extract-plugin
export default {"toggle":"PageSizeDropdown_toggle__Hd90P"};